import React from "react";

export default function Logo({ className = "h-12 w-auto" }) {
  return (
    <img
      src="/logo-gold-official.png"
      alt="Suryavansh Exim Pvt. Ltd."
      className={`${className} object-contain brightness-125 contrast-110 filter drop-shadow-[0_0_20px_rgba(255,215,0,0.6)]`}
      draggable="false"
    />
  );
}
